import type { FaireProductEntity } from "../../entity_types/product";

export const p_9gzjqx94jp: FaireProductEntity = {
  token: "p_9gzjqx94jp",
  type: "product",
  name: "Espresso Martini Sticker",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/74b46f54f5555c51797347b8bf168cc53b71e0512b1ffdaec4ccc340a7f6ae7e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4317a45429c29b0ac3ce5b54d1f35640f050eac91377b5a6cf98edd9b2848cda.jpeg",
  ],
  priceDollars: 2.5,
  description:
    "Water-resistant, Die-cut Stickers with crack and peel backing. Have fun decorating those laptops and water bottles!",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:08.434Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
